import React, { useState } from "react";
import { WealthHeroSection } from "./WealthHeroSection";
import { WealthStatsSection } from "./WealthStatsSection";
import { BravoSolutionSection } from "./BravoSolutionSection";
import { AdvisorIntelligenceSection } from "./AdvisorIntelligenceSection";
import { ParticipantExperienceSection } from "./ParticipantExperienceSection";
import { WealthBenefitsSection } from "./WealthBenefitsSection";
import { WealthGetStartedSection } from "./WealthGetStartedSection";
import { CalculatorModal } from "@/components/ui/CalculatorModal";
import { WealthCalculator } from "./WealthCalculator";

export const WealthManagementLayout: React.FC = () => {
  const [isCalcOpen, setIsCalcOpen] = useState(false);

  return (
    <>
      <WealthHeroSection />
      <WealthStatsSection onOpenCalc={() => setIsCalcOpen(true)} />
      <BravoSolutionSection />
      <AdvisorIntelligenceSection />
      <ParticipantExperienceSection />
      <WealthBenefitsSection />
      <WealthGetStartedSection />
      <CalculatorModal isOpen={isCalcOpen} onClose={() => setIsCalcOpen(false)}>
        <WealthCalculator />
      </CalculatorModal>
    </>
  );
};
